// ─── Demo Data ────────────────────────────────────────────────────
// Pedigree layout: generations as rows, bottom-up
// Level 0 (bottom): You
// Level 1 (middle): Father —❤— Mother, Uncle (left of Father), Aunt (right of Mother)
// Level 2 (top): Grandparent couples

// ── Uncle (Mother's side husband) family ──
const UNCLES_FAMILY = {
  root: { id: 15, name: "Uncle (Mother's side husband)", gender: 'MALE', isLiving: true, kinshipTerm: 'Self',
    spouse: { id: 9, name: "Aunt (Mother's side)", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav' } },
  rootChildren: [
    { id: 60, name: 'Older Cousin (M\'s side)', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
    { id: 61, name: 'Younger Cousin (M\'s side)', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav nyiem' },
  ],
  rootSiblings: [
    { id: 40, name: "Uncle's Older Brother", gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv hlua' },
    { id: 41, name: "Uncle's Younger Sister", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ncaav' },
  ],
  parentGeneration: {
    father: { id: 30, name: "Uncle's Father", gender: 'MALE', isLiving: false, kinshipTerm: 'Dauv' },
    mother: { id: 31, name: "Uncle's Mother", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Nerh' },
    fatherSiblings: [
      { id: 32, name: "Uncle's Paternal Uncle", gender: 'MALE', isLiving: false, kinshipTerm: 'Dauv lung' },
    ],
    motherSiblings: [
      { id: 33, name: "Uncle's Maternal Aunt", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Nerh ntsaav' },
    ],
  },
  grandparentGeneration: {
    paternalGrandfather: { id: 34, name: "Uncle's Paternal Grandfather", gender: 'MALE', isLiving: false, kinshipTerm: 'Nang' },
    paternalGrandmother: { id: 35, name: "Uncle's Paternal Grandmother", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Nyang' },
    maternalGrandfather: { id: 36, name: "Uncle's Maternal Grandfather", gender: 'MALE', isLiving: false, kinshipTerm: 'Ndaav nyiem' },
    maternalGrandmother: { id: 37, name: "Uncle's Maternal Grandmother", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Ndaav nyiem' },
  },
};

// ── Aunt (Father's side wife) family ──
const AUNTS_FAMILY = {
  root: { id: 14, name: "Aunt (Father's side wife)", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Self',
    spouse: { id: 8, name: "Uncle (Father's side)", gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung' } },
  rootChildren: [
    { id: 62, name: 'Cousin F1', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Dauv mbing nyiem' },
    { id: 63, name: 'Cousin F2', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
    { id: 64, name: 'Cousin F3', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh mbing nyiem' },
  ],
  rootSiblings: [
    { id: 50, name: "Aunt's Older Sister", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh hluav' },
    { id: 51, name: "Aunt's Younger Brother", gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv ncaav' },
  ],
  parentGeneration: {
    father: { id: 52, name: "Aunt's Father", gender: 'MALE', isLiving: false, kinshipTerm: 'Dauv' },
    mother: { id: 53, name: "Aunt's Mother", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Nerh' },
    fatherSiblings: [],
    motherSiblings: [
      { id: 54, name: "Aunt's Maternal Uncle", gender: 'MALE', isLiving: false, kinshipTerm: 'Nerh dauv' },
    ],
  },
  grandparentGeneration: {
    paternalGrandfather: { id: 55, name: "Aunt's Paternal Grandfather", gender: 'MALE', isLiving: false, kinshipTerm: 'Nang' },
    paternalGrandmother: { id: 56, name: "Aunt's Paternal Grandmother", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Nyang' },
    maternalGrandfather: { id: 57, name: "Aunt's Maternal Grandfather", gender: 'MALE', isLiving: false, kinshipTerm: 'Ndaav nyiem' },
    maternalGrandmother: { id: 58, name: "Aunt's Maternal Grandmother", gender: 'FEMALE', isLiving: false, kinshipTerm: 'Ndaav nyiem' },
  },
};

const DEMO_PEDIGREE = {
  root: { id: 1, name: 'You', gender: 'MALE', isLiving: true, kinshipTerm: 'Self',
    spouse: { id: 80, name: 'Wife', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Mbing' } },
  rootSiblings: [
    { id: 12, name: 'Older Brother', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv hlua',
      spouse: { id: 94, name: 'Sister-in-Law', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Mbing' },
      children: [
        { id: 100, name: 'Nephew 1', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv' },
        { id: 101, name: 'Niece 1', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh' },
        { id: 102, name: 'Nephew 2', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv' },
      ] },
    { id: 13, name: 'Younger Sister', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ncaav',
      spouse: { id: 95, name: 'Brother-in-Law', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv ntsaav' },
      children: [
        { id: 103, name: 'Niece 2', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh' },
        { id: 104, name: 'Nephew 3', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv' },
        { id: 105, name: 'Niece 3', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh' },
        { id: 106, name: 'Nephew 4', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv' },
        { id: 107, name: 'Niece 4', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh' },
      ] },
  ],
  rootChildren: [
    { id: 70, name: 'Son', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv' },
    { id: 71, name: 'Daughter', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh' },
  ],
  parentGeneration: {
    father: { id: 2, name: 'Father', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv' },
    mother: { id: 5, name: 'Mother', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh' },
    fatherSiblings: [
      { id: 8, name: "Uncle (F's side)", gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung',
        spouse: { id: 14, name: "Aunt (F's wife)", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Mbing', family: AUNTS_FAMILY },
        children: [
          { id: 62, name: 'Cousin F1', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Dauv mbing nyiem' },
          { id: 63, name: 'Cousin F2', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
          { id: 64, name: 'Cousin F3', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh mbing nyiem' },
        ] },
      { id: 10, name: "Aunt (F's side)", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Dauv mbing',
        spouse: { id: 81, name: "Uncle (F's in-law)", gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv ntsaav' },
        children: [
          { id: 90, name: 'Cousin F4', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
          { id: 91, name: 'Cousin F5', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh mbing nyiem' },
          { id: 92, name: 'Cousin F6', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
          { id: 93, name: 'Cousin F7', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh mbing nyiem' },
        ] },
    ],
    motherSiblings: [
      { id: 9, name: "Aunt (M's side)", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav',
        spouse: { id: 15, name: "Uncle (M's husband)", gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv ntsaav', family: UNCLES_FAMILY },
        children: [
          { id: 60, name: 'Cousin M1', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
          { id: 61, name: 'Cousin M2', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav nyiem' },
          { id: 82, name: 'Cousin M3', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
        ] },
      { id: 11, name: "Uncle (M's side)", gender: 'MALE', isLiving: true, kinshipTerm: 'Nerh dauv',
        spouse: { id: 83, name: "Aunt (M's in-law)", gender: 'FEMALE', isLiving: true, kinshipTerm: 'Mbing' },
        children: [
          { id: 84, name: 'Cousin M4', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav nyiem' },
          { id: 85, name: 'Cousin M5', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
          { id: 86, name: 'Cousin M6', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav nyiem' },
          { id: 87, name: 'Cousin M7', gender: 'MALE', isLiving: true, kinshipTerm: 'Dauv lung nyiem' },
          { id: 88, name: 'Cousin M8', gender: 'FEMALE', isLiving: true, kinshipTerm: 'Nerh ntsaav nyiem' },
        ] },
    ],
  },
  grandparentGeneration: {
    paternalGrandfather: { id: 3, name: 'Paternal Grandfather', gender: 'MALE', isLiving: false, kinshipTerm: 'Nang' },
    paternalGrandmother: { id: 4, name: 'Paternal Grandmother', gender: 'FEMALE', isLiving: false, kinshipTerm: 'Nyang' },
    maternalGrandfather: { id: 6, name: 'Maternal Grandfather', gender: 'MALE', isLiving: false, kinshipTerm: 'Ndaav nyiem' },
    maternalGrandmother: { id: 7, name: 'Maternal Grandmother', gender: 'FEMALE', isLiving: false, kinshipTerm: 'Ndaav nyiem' },
  },
};

export { DEMO_PEDIGREE, UNCLES_FAMILY, AUNTS_FAMILY };